module.exports = __webpack_public_path__ + "img/material.d6e5a631.svg";